import TicketHttp from "../../ticketHttp";

class ShowTimeServices{
    static async addShowtime(data){
        // console.log("show time data",data)
        return TicketHttp.post('/movieShowTime/create',data)
    }
    static async Showtimes(){
        // console.log("show time data",data)
        return TicketHttp.get('/movieShowTime/showTimes')
    }
    static async getShowtimeById(id){
        return TicketHttp.get(`/movieShowTime/showTimes/${id}`);
    }
    static async updateShowTime(showtimeId,data){
        console.log("data in updateshowtime",data)
        return TicketHttp.update(`/movieShowTime/updateShowTimes/${showtimeId}`,data)
    }
    static async  deleteTheatreShowTime(showtimeId,theatreId){
          return TicketHttp.delete(`/movieShowTime/${showtimeId}/theatres/${theatreId}`)
    }

    static async createShowtime(data){
        console.log("show time data",data)
        return TicketHttp.post('/movieShowSchedule/createShowtime',data)
    }

    static async getAllShowSchedules(theatreName =''){
        // console.log("show time data",data)
        const query = theatreName ? `?theatreName=${encodeURIComponent(theatreName)}` : '';
        return TicketHttp.get(`/movieShowSchedule/getAllShowSchedules${query}`)
    }

    static async updateShowSchedule(id,data){
        return TicketHttp.update(`/movieShowSchedule/updateShowSchedule/${id}`, data);


    }

    static async deleteShowSchedule(id){
        return TicketHttp.delete(`/movieShowSchedule/deleteShowSchedule/${id}`);


    }

    // static async getMovies(theatreName = '') {
    //     const query = theatreName ? `?theatreName=${encodeURIComponent(theatreName)}` : '';
    //     return TicketHttp.get(`/movies${query}`);
    //   }
}
export default ShowTimeServices